var map = {
	"./Add.tsx": 63851,
	"./AddOutline.tsx": 19636,
	"./AmericanExpressDark.tsx": 37264,
	"./ArrowDown.tsx": 17353,
	"./ArrowGo.tsx": 18097,
	"./ArrowLeft.tsx": 29426,
	"./ArrowRight.tsx": 29442,
	"./ArrowUp.tsx": 1899,
	"./Arrows.tsx": 15222,
	"./Barcode.tsx": 82083,
	"./Calendar.tsx": 14514,
	"./CaretDown.tsx": 85453,
	"./CaretLeft.tsx": 31817,
	"./CaretRight.tsx": 42418,
	"./CaretUp.tsx": 85400,
	"./Chat.tsx": 85053,
	"./Checkmark.tsx": 53942,
	"./CheckmarkGylph.tsx": 65933,
	"./CheckmarkOutline.tsx": 28321,
	"./ChevronDown.tsx": 52781,
	"./ChevronLeft.tsx": 93080,
	"./ChevronRight.tsx": 9242,
	"./ChevronUp.tsx": 46133,
	"./Close.tsx": 58289,
	"./CloseOutline.tsx": 33454,
	"./Copy.tsx": 4022,
	"./Delete.tsx": 68986,
	"./DeliveryTruck.tsx": 34519,
	"./Directions.tsx": 28450,
	"./DiscoverDark.tsx": 26317,
	"./Download.tsx": 90091,
	"./Edit.tsx": 39986,
	"./Error.tsx": 12622,
	"./Facebook.tsx": 71869,
	"./Favorite.tsx": 85031,
	"./Fb.tsx": 25863,
	"./Filter.tsx": 13609,
	"./Grid.tsx": 11482,
	"./Help.tsx": 94399,
	"./IconReturn.tsx": 51026,
	"./In.tsx": 77682,
	"./Info.tsx": 34415,
	"./Invoices.tsx": 83738,
	"./Invoices2.tsx": 39324,
	"./Invoices3.tsx": 17655,
	"./Link.tsx": 57868,
	"./Linkedin.tsx": 68582,
	"./List.tsx": 92519,
	"./Location.tsx": 58606,
	"./LogIn.tsx": 5884,
	"./MasterCardDark.tsx": 34167,
	"./Measure.tsx": 58165,
	"./MeasureBadge.tsx": 11040,
	"./Menu.tsx": 84831,
	"./MenuDots.tsx": 11317,
	"./Message.tsx": 21002,
	"./MiniMenu.tsx": 35149,
	"./Minus.tsx": 54310,
	"./Move.tsx": 5324,
	"./MyAccount.tsx": 1571,
	"./Notifications.tsx": 59432,
	"./OrderHistory.tsx": 85028,
	"./Pdf.tsx": 29135,
	"./Phone.tsx": 17878,
	"./PickUpInstruction.tsx": 85881,
	"./Pickup.tsx": 42406,
	"./Play.tsx": 96906,
	"./Print.tsx": 16726,
	"./QrCode.tsx": 68339,
	"./QuickOrder.tsx": 90264,
	"./QuoteRequest.tsx": 52047,
	"./Salesman.tsx": 13257,
	"./Share.tsx": 34579,
	"./ShoppingCart.tsx": 42088,
	"./ShoppingLists.tsx": 44823,
	"./TableGrid.tsx": 64778,
	"./Twitter.tsx": 64629,
	"./User.tsx": 87527,
	"./VisaDark.tsx": 1731,
	"./Warning.tsx": 52957,
	"./WarningGlyph.tsx": 12845,
	"./WarningStock.tsx": 31219,
	"./Wishlist.tsx": 85014,
	"./Youtube.tsx": 49327
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97320;